export const wrapperMotion = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
};

export const cardMotion = {
    initial: { y: 40, scale: 0.8 },
    animate: { y: 0, scale: 1 },
    exit: { y: 40, scale: 0.8 },
};
